import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExamsTemplateContainerService {



  private examDataSubject = new BehaviorSubject({});
  examData = this.examDataSubject.asObservable();

  constructor() {}

  /**
   * Este método tiene como objetivo actualizar el observable que
   * contiene la información del examen que se va a cargar
   * @param data
   */
  updateDataExam(data: any): void{
    this.examDataSubject.next(data);
  }


}
